import { PropsWithChildren } from "react";
import "./wrapper.scss";

export const JournalSectionWrapper = ({ children }: PropsWithChildren) => {
  return <div className="journal-section-wrapper">{children}</div>;
};